module.exports = __webpack_public_path__ + "static/img/hwaqapp_bg_banner.d6a813a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hwaqapp_bg_banner.png
// module id = Kxnl
// module chunks = 21